<template>
  <div
    class="full-screen-section"
    :style="{ transform: 'translateY(' + translateY + '%)' }"
  >
    <!-- 工业数智化首页 Section 0 -->
    <div
      class="full-screen-video-section section0"
      :class="{ active: this.$store.state.currentIndex === 0 }"
    >
      <!-- 工业数智化背景动效 -->
      <div class="industrial-tech-bg">
        <!-- 动态网格背景 -->
        <div class="grid-background">
          <div class="grid-line horizontal" v-for="i in 12" :key="'h-' + i"></div>
          <div class="grid-line vertical" v-for="i in 20" :key="'v-' + i"></div>
        </div>
        
        <!-- 数据流网络 -->
        <div class="data-network">
          <div class="network-line" v-for="i in 15" :key="'line-' + i"></div>
        </div>
        
        <!-- 数据节点 -->
        <div class="data-nodes">
          <div class="node" v-for="i in 25" :key="'node-' + i" :style="{
            left: Math.random() * 90 + 5 + '%',
            top: Math.random() * 80 + 10 + '%'
          }"></div>
        </div>
        
        <!-- 数据流动粒子 -->
        <div class="data-flow">
          <div class="flow-particle" v-for="i in 15" :key="'particle-' + i"></div>
        </div>
        
        <!-- 数码雨 -->
        <div class="digital-rain">
          <div class="rain-column" v-for="i in 8" :key="'rain-' + i" :style="{
            left: (i * 12) + '%'
          }">
            <span v-for="j in 10" :key="'char-' + j" class="rain-char">
              {{ Math.random() > 0.5 ? '1' : '0' }}
            </span>
          </div>
        </div>
        
        <!-- 工业装卸设备轮廓 -->
        <div class="equipment-silhouette">
          <div class="crane-arm"></div>
          <div class="container-blocks">
            <div class="block" v-for="i in 6" :key="'block-' + i"></div>
          </div>
          <div class="ship-outline"></div>
        </div>
        
        <!-- HUD界面元素 -->
        <div class="hud-elements">
          <div class="hud-corner top-left"></div>
          <div class="hud-corner top-right"></div>
          <div class="hud-corner bottom-left"></div>
          <div class="hud-corner bottom-right"></div>
          <div class="scan-line"></div>
        </div>
        
        <!-- 数据显示面板 -->
        <div class="data-panels">
          <div class="panel left-panel">
            <div class="panel-line" v-for="i in 4" :key="'pl-' + i"></div>
          </div>
          <div class="panel right-panel">
            <div class="panel-dot" v-for="i in 6" :key="'pd-' + i"></div>
          </div>
        </div>
        
        <!-- 卫星系统 -->
        <div class="satellite-system">
          <!-- 中央核心 -->
          <div class="satellite-core"></div>
          
          <!-- 内层卫星轨道 -->
          <div class="orbit inner-orbit">
            <div class="satellite sat-1"></div>
            <div class="satellite sat-2"></div>
          </div>
          
          <!-- 中层卫星轨道 -->
          <div class="orbit middle-orbit">
            <div class="satellite sat-3"></div>
            <div class="satellite sat-4"></div>
            <div class="satellite sat-5"></div>
          </div>
          
          <!-- 外层卫星轨道 -->
          <div class="orbit outer-orbit">
            <div class="satellite sat-6"></div>
            <div class="satellite sat-7"></div>
            <div class="satellite sat-8"></div>
            <div class="satellite sat-9"></div>
          </div>
        </div>
      </div>

      <div class="overlay"></div>

      <!-- 主标题内容 -->
      <div class="content" style="position: relative; z-index: 10;">
        <div class="title-container">
          <h1 class="main-title">
            <span class="title-line1">大型干散货装卸领域的</span>
            <span class="title-line2">工业数智化综合解决方案提供商</span>
          </h1>
          <div class="subtitle-container">
            <p class="subtitle-text">
              单体设备自动化&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;流程协同一体化&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;生产运维智能化&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;经营管理智慧化
            </p>
          </div>
        </div>
        <el-button
          class="elButton section0-btn"
          round
          @click="$router.push('/productCenterIndex')"
        >了解更多</el-button
        >
      </div>
    </div>

    <div
      class="full-screen-video-section section1"
      :class="{ active: this.$store.state.currentIndex === 1 }"
    >
      <!-- 科技感背景动效替代视频 -->
      <div class="tech-background">
        <!-- 动态网格背景 -->
        <div class="grid-bg"></div>

        <!-- 多层粒子效果 -->
        <div class="particle-layer">
          <div class="particle p1"></div>
          <div class="particle p2"></div>
          <div class="particle p3"></div>
          <div class="particle p4"></div>
          <div class="particle p5"></div>
          <div class="particle p6"></div>
          <div class="particle p7"></div>
          <div class="particle p8"></div>
          <div class="particle p9"></div>
          <div class="particle p10"></div>
          <div class="particle p11"></div>
          <div class="particle p12"></div>
        </div>

        <!-- 上升的数据流光效 -->
        <div class="data-streams">
          <div class="stream stream-1"></div>
          <div class="stream stream-2"></div>
          <div class="stream stream-3"></div>
          <div class="stream stream-4"></div>
          <div class="stream stream-5"></div>
          <div class="stream stream-6"></div>
          <div class="stream stream-7"></div>
        </div>

        <!-- 几何图形背景层 -->
        <div class="geometric-shapes">
          <div class="shape triangle tri-1"></div>
          <div class="shape triangle tri-2"></div>
          <div class="shape triangle tri-3"></div>
          <div class="shape circle circ-1"></div>
          <div class="shape circle circ-2"></div>
          <div class="shape diamond dia-1"></div>
          <div class="shape diamond dia-2"></div>
        </div>

        <!-- 光束扫描效果 -->
        <div class="light-beams">
          <div class="beam beam-diagonal-1"></div>
          <div class="beam beam-diagonal-2"></div>
          <div class="beam beam-horizontal"></div>
        </div>

        <!-- 波纹扩散效果 -->
        <div class="ripple-effects">
          <div class="ripple ripple-1"></div>
          <div class="ripple ripple-2"></div>
          <div class="ripple ripple-3"></div>
        </div>

        <!-- 代码雨背景 -->
        <div class="code-rain">
          <div class="code-column cc-1">01101</div>
          <div class="code-column cc-2">11010</div>
          <div class="code-column cc-3">00110</div>
          <div class="code-column cc-4">10101</div>
          <div class="code-column cc-5">11100</div>
        </div>

        <!-- 能量脉冲网络 -->
        <div class="energy-network">
          <div class="network-node node-1"></div>
          <div class="network-node node-2"></div>
          <div class="network-node node-3"></div>
          <div class="network-node node-4"></div>
          <div class="network-connection conn-1"></div>
          <div class="network-connection conn-2"></div>
          <div class="network-connection conn-3"></div>
        </div>

        <!-- 右侧科技界面 - 统一设计 -->
        <div class="tech-elements-right">
          <!-- 主核心系统 -->
          <div class="main-core-system">
            <div class="core-center">
              <div class="core-sphere"></div>
              <div class="core-ring ring-1"></div>
              <div class="core-ring ring-2"></div>
              <div class="core-ring ring-3"></div>
            </div>

            <!-- 卫星系统 -->
            <div class="satellite-system">
              <div class="satellite sat-1"></div>
              <div class="satellite sat-2"></div>
              <div class="satellite sat-3"></div>
              <div class="satellite sat-4"></div>
            </div>

            <!-- 连接线网络 -->
            <div class="connection-network">
              <div class="conn-line line-1"></div>
              <div class="conn-line line-2"></div>
              <div class="conn-line line-3"></div>
              <div class="conn-line line-4"></div>
            </div>

            <!-- 数据流 -->
            <div class="data-flow-system">
              <div class="data-particle dp-1"></div>
              <div class="data-particle dp-2"></div>
              <div class="data-particle dp-3"></div>
              <div class="data-particle dp-4"></div>
              <div class="data-particle dp-5"></div>
              <div class="data-particle dp-6"></div>
            </div>

            <!-- 能量场 -->
            <div class="energy-field">
              <div class="field-layer layer-1"></div>
              <div class="field-layer layer-2"></div>
            </div>
          </div>
        </div>

        <!-- 左下角装饰元素 -->
        <div class="corner-decoration">
          <div class="corner-line line-1"></div>
          <div class="corner-line line-2"></div>
          <div class="corner-dot"></div>
        </div>
      </div>

      <div class="overlay"></div>

      <div class="content" style="position: relative">
        <h1
          style="
            position: absolute;
            top: 35%;
            font-size: calc(100vw * 56 / 1920);
            left: 15%;
            user-select: none;
            font-weight: 600;
            text-shadow: 0 0 30px rgba(0, 255, 255, 0.5);
          "
          class="fade-in-text glitch-text"
        >
          绿色智慧散货港口全流程综合管控解决方案
        </h1>
        <div
          style="
            position: absolute;
            top: 44%;
            left: 15%;
            width: calc(100vw * 60 / 1920);
            height: 2px;
            background: #ffffff;
            margin-top: calc(100vw * 15 / 1920);
            margin-bottom: calc(100vw * 15 / 1920);
          "
          class="fade-in-text-delay"
        ></div>
        <p
          style="
            position: absolute;
            top: 50%;
            font-size: calc(100vw * 26 / 1920);
            left: 15%;
            width: calc(100vw * 700 / 1920);
            user-select: none;
            text-align: left;
          "
          class="fade-in-text-delay"
        >
          装备自动化 &nbsp;&nbsp;/&nbsp;&nbsp; 协同智能化 &nbsp;&nbsp;/&nbsp;&nbsp; 决策智慧化 &nbsp;&nbsp;/&nbsp;&nbsp; 管理数字化
        </p>
        <el-button
          class="elButton"
          round
          @click="$router.push('/productCenterIndex')"
          >了解更多</el-button
        >
      </div>
    </div>
    <div
      class="full-screen-video-section section2"
      :class="{ active: $store.state.currentIndex === 2 }"
    >
      <video autoplay muted loop>
        <source src="../../assets/home/lizi.mp4" type="video/mp4" />
      </video>
      <div class="overlay"></div>
      <div class="content">
        <h1
          style="
            font-size: calc(100vw * 48 / 1920);
            margin-bottom: 2%;
            user-select: none;
          "
        >
          引领散货装卸数智化建设，构筑互联网+的智能运维平台
        </h1>
        <h3
          style="
            font-size: calc(100vw * 24 / 1920);
            font-weight: 400;
            user-select: none;
          "
        >
          单体设备自动化、流程协同一体化、生产运维智能化、经营管理智慧化
        </h3>
        <el-button
          class="elButton"
          round
          @click="$router.push('/productCenterIndex')"
          >了解更多 》</el-button
        >
      </div>
    </div>
    <div
      class="full-screen-video-section section3"
      :class="{ active: $store.state.currentIndex === 3 }"
    >
      <!-- <video autoplay muted loop>
        <source
          src="https://www.w3schools.com/html/mov_bbb.mp4"
          type="video/mp4"
        />
      </video> -->
      <video autoplay muted loop>
        <source src="../../assets/home/swiper3.mp4" type="video/mp4" />
      </video>
      <div class="overlay"></div>
      <div class="content">
        <el-button
          class="elButton"
          round
          @click="$router.push('/productCenterIndex')"
          >了解更多 》</el-button
        >
      </div>
    </div>
    <div
      class="full-screen-video-section section4"
      :class="{ active: $store.state.currentIndex === 4 }"
    >
      <!-- <video autoplay muted loop>
        <source
          src="https://www.w3schools.com/html/mov_bbb.mp4"
          type="video/mp4"
        />
      </video> -->
      <video autoplay muted loop>
        <source src="../../assets/home/daji.mp4" type="video/mp4" />
      </video>
      <div class="overlay"></div>
      <div class="content" style="position: relative">
        <h1
          style="
            position: absolute;
            top: 12%;
            font-size: calc(100vw * 48 / 1920);
            left: 37%;
            user-select: none;
          "
        >
          数字孪生仿真建模系统
        </h1>
        <h2
          style="
            position: absolute;
            top: 20%;
            font-size: calc(100vw * 28 / 1920);
            left: 42%;
            font-weight: 400;
            user-select: none;
          "
        >
          ——虚拟仿真技术赋能工厂数字化转型
        </h2>
      </div>
    </div>
    <div
      class="full-screen-video-section section5"
      :class="{ active: $store.state.currentIndex === 5 }"
    >
      <video autoplay muted loop>
        <source src="../../assets/home/ditu.mp4" type="video/mp4" />
      </video>
      <div class="overlay"></div>
      <div class="content" style="position: relative">
        <h1
          style="
            position: absolute;
            top: 35%;
            font-size: calc(100vw * 48 / 1920);
            left: 15%;
            user-select: none;
            font-weight: 600;
          "
        >
          业务范围分布广阔，持续为客户创造价值
        </h1>
        <p
          style="
            position: absolute;
            top: 45%;
            font-size: calc(100vw * 18 / 1920);
            left: 15%;
            width: calc(100vw * 569 / 1920);
            user-select: none;
            text-align: left;
          "
        >
          公司具有开展全球范围业务能力，项目产品已经逐步拓展至环渤海、长三角、珠三角、东南沿海、西南沿海等省份，未来将进一步开拓其他地区市场。
        </p>
        <el-button class="elButton" round @click="$router.push('/aboutIndex')"
          >了解更多 》</el-button
        >
      </div>
    </div>
    <div
      class="full-screen-video-section section6"
      :class="{ active: $store.state.currentIndex === 6 }"
    >
      <!-- 环形科技动效背景 -->
      <div class="circular-tech-background">
        <!-- 中心发光核心 -->
        <div class="central-core">
          <div class="core-ring ring-1"></div>
          <div class="core-ring ring-2"></div>
          <div class="core-ring ring-3"></div>
          <div class="core-center"></div>
        </div>

        <!-- 多层旋转环 -->
        <div class="rotating-rings">
          <div class="ring outer-ring-1"></div>
          <div class="ring outer-ring-2"></div>
          <div class="ring outer-ring-3"></div>
          <div class="ring outer-ring-4"></div>
        </div>

        <!-- 轨道粒子 -->
        <div class="orbital-particles">
          <div class="particle-orbit orbit-1">
            <div class="orbit-particle"></div>
          </div>
          <div class="particle-orbit orbit-2">
            <div class="orbit-particle"></div>
          </div>
          <div class="particle-orbit orbit-3">
            <div class="orbit-particle"></div>
          </div>
        </div>

        <!-- 脉冲波纹 -->
        <div class="pulse-waves">
          <div class="pulse-wave wave-1"></div>
          <div class="pulse-wave wave-2"></div>
          <div class="pulse-wave wave-3"></div>
        </div>

        <!-- 数据流环形轨道 -->
        <div class="data-orbital-streams">
          <div class="stream-orbit stream-orbit-1">
            <div class="stream-dot dot-1"></div>
            <div class="stream-dot dot-2"></div>
            <div class="stream-dot dot-3"></div>
          </div>
          <div class="stream-orbit stream-orbit-2">
            <div class="stream-dot dot-1"></div>
            <div class="stream-dot dot-2"></div>
            <div class="stream-dot dot-3"></div>
          </div>
        </div>

        <!-- 能量射线 -->
        <div class="energy-rays">
          <div class="ray ray-1"></div>
          <div class="ray ray-2"></div>
          <div class="ray ray-3"></div>
          <div class="ray ray-4"></div>
          <div class="ray ray-5"></div>
          <div class="ray ray-6"></div>
        </div>

        <!-- 外围装饰环 -->
        <div class="decorative-elements">
          <div class="deco-arc arc-1"></div>
          <div class="deco-arc arc-2"></div>
          <div class="deco-arc arc-3"></div>
          <div class="deco-arc arc-4"></div>
        </div>
      </div>
      <div class="overlay"></div>
      <div class="content">
        <h1 class="section6-title">滨沅科技，共筑散货港口全流程综合管控绿色智慧未来</h1>
      </div>
    </div>
    <div
      class="full-screen-video-section section7"
      :class="{ active: $store.state.currentIndex === 7 }"
    >
      <video autoplay muted loop>
        <source src="../../assets/home/虚拟展厅视频.mp4" type="video/mp4" />
      </video>
      <div class="overlay"></div>
      <div class="content"></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
body,
html {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden !important;
}

.full-screen-section {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.8s ease-in-out;
}

.full-screen-video-section {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.full-screen-video-section video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
}
.full-screen-video-section img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
}

.full-screen-video-section .overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: transparent;
}

.full-screen-video-section .content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
  height: 100%;
}

/* 设置每个section的位置 */
.section0 {
  top: 0;
  background: radial-gradient(ellipse at center center, #1d2342 0%, #0c1130 40%, #090c22 100%);
  overflow: hidden;

  .elButton {
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #d91724 !important;
    color: white !important;
    font-weight: 500;
    font-size: calc(100vw * 18 / 1920);
    padding: calc(100vw * 15 / 1920) calc(100vw * 40 / 1920);
    border: none !important;
    transition: all 0.3s ease;
    overflow: hidden;
    z-index: 10;
  }

  .elButton::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.7s;
  }

  .elButton:hover::before {
    left: 100%;
  }

  .elButton:hover {
    transform: translateX(-50%) scale(1.1);
    transition: transform 0.3s ease-in-out;
    box-shadow: 0 0 30px rgba(217, 23, 36, 0.8);
  }

  /* 静态数据流背景 */
  .simple-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: transparent;
    pointer-events: none;
  }
}


/* 删除原有的相关动画 */
@keyframes charFade {
  0% {
    opacity: 0;
    transform: scale(0.5) translateY(-10px);
    filter: blur(3px);
  }
  20% {
    opacity: 0.8;
    transform: scale(1) translateY(0);
    filter: blur(0);
  }
  80% {
    opacity: 0.8;
    transform: scale(1) translateY(0);
    filter: blur(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.5) translateY(10px);
    filter: blur(3px);
  }
}

/* 文字流动动画 */
@keyframes dataColumnFlow {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(50%);
  }
}

/* 字符淡入淡出动画 */
@keyframes charFade {
  0% {
    opacity: 0;
    transform: scale(0.5) translateY(-10px);
    filter: blur(3px);
  }
  20% {
    opacity: 0.8;
    transform: scale(1) translateY(0);
    filter: blur(0);
  }
  80% {
    opacity: 0.8;
    transform: scale(1) translateY(0);
    filter: blur(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.5) translateY(10px);
    filter: blur(3px);
  }
}




/* 霓虹数据流 */
.neon-data-flow {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.4;
  pointer-events: none;
}

.neon-stream {
  position: absolute;
  width: 100%;
  height: 3px;
  top: 50%;
  animation: neonFlow 8s ease-in-out infinite;
}

.neon-particle {
  position: absolute;
  width: 20px;
  height: 20px;
  background: radial-gradient(
    circle,
    rgba(0, 255, 255, 1) 0%,
    rgba(0, 255, 255, 0.5) 40%,
    transparent 70%
  );
  border-radius: 50%;
  filter: blur(1px);
}

.neon-trail {
  position: absolute;
  width: 200px;
  height: 2px;
  background: linear-gradient(
    to right,
    transparent,
    rgba(0, 255, 255, 0.8),
    rgba(0, 255, 0, 0.6),
    transparent
  );
  left: -180px;
  top: 50%;
  transform: translateY(-50%);
}

/* 二进制波浪 */
.binary-waves {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  opacity: 0.3;
  pointer-events: none;
}

.wave-layer {
  width: 200%;
  height: 30px;
  position: relative;
  left: -50%;
}

.binary-wave {
  font-family: 'Courier New', monospace;
  font-size: 24px;
  color: #00ff00;
  letter-spacing: 8px;
  white-space: nowrap;
  animation: binaryWave 12s linear infinite;
  text-shadow: 
    0 0 5px currentColor,
    0 0 10px currentColor;
  filter: brightness(1.2);
}

/* Section0 标题样式 */
.section0 .title-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 95%;
  //max-width: 1600px;
}

.section0 .main-title {
  margin: 0 0 30px 0;
}

.section0 .title-line1 {
  display: block;
  font-size: calc(100vw * 70 / 1920);
  color: rgba(255, 255, 255, 0.95);
  font-weight: 700;
  margin-bottom: 15px;
  letter-spacing: 6px;
  text-shadow:
    0 0 40px rgba(0, 150, 255, 0.8),
    0 0 80px rgba(0, 150, 255, 0.6),
    0 0 120px rgba(0, 150, 255, 0.4);
  opacity: 0;
  animation: fadeInUp 1s ease forwards, titleGlow 4s ease-in-out 1s infinite;
}

.section0 .title-line2 {
  display: block;
  font-size: calc(100vw * 70 / 1920);
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 6px;
  text-shadow:
    0 0 40px rgba(0, 150, 255, 0.8),
    0 0 80px rgba(0, 150, 255, 0.6),
    0 0 120px rgba(0, 150, 255, 0.4);
  opacity: 0;
  animation: fadeInUp 1s ease 0.3s forwards, titleGlow 4s ease-in-out 1.3s infinite;
  margin-bottom: calc(100vw * 60 / 1920);
}

.section0 .subtitle-container {
  margin-top: 20px;
}
.section0-btn {
  margin-top: calc(100vw * 180 / 1920);
}
.section0 .subtitle-text {
  font-size: calc(100vw * 20 / 1920);
  color: rgba(255, 255, 255, 0.8);
  opacity: 0;
  animation: fadeInUp 1s ease 0.6s forwards;
}

/* 工业数智化背景动效 */
.section0 .industrial-tech-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0.6; /* 调降透明度 */
  overflow: hidden;
  filter: brightness(1.15); /* 调降亮度 */
}

/* 动态网格背景 */
.section0 .grid-background {
  position: absolute;
  width: 100%;
  height: 100%;
}

.section0 .grid-line {
  position: absolute;
  animation: gridPulse 6s ease-in-out infinite;
}

.section0 .grid-line.horizontal {
  background: linear-gradient(90deg, transparent, rgba(0, 200, 255, 0.25), transparent);
  filter: blur(1px) brightness(1.2); /* 虚化横线 + 适度增亮 */
}

.section0 .grid-line.vertical {
  background: linear-gradient(0deg, transparent, rgba(0, 200, 255, 0.5), transparent);
  filter: brightness(1.1);
}

.section0 .grid-line.horizontal {
  width: 100%;
  height: 1px;
}

.section0 .grid-line.horizontal:nth-child(1) { top: 10%; animation-delay: 0s; }
.section0 .grid-line.horizontal:nth-child(2) { top: 18%; animation-delay: 0.5s; }
.section0 .grid-line.horizontal:nth-child(3) { top: 26%; animation-delay: 1s; }
.section0 .grid-line.horizontal:nth-child(4) { top: 34%; animation-delay: 1.5s; }
.section0 .grid-line.horizontal:nth-child(5) { top: 42%; animation-delay: 2s; }
.section0 .grid-line.horizontal:nth-child(6) { top: 50%; animation-delay: 2.5s; }
.section0 .grid-line.horizontal:nth-child(7) { top: 58%; animation-delay: 3s; }
.section0 .grid-line.horizontal:nth-child(8) { top: 66%; animation-delay: 3.5s; }
.section0 .grid-line.horizontal:nth-child(9) { top: 74%; animation-delay: 4s; }
.section0 .grid-line.horizontal:nth-child(10) { top: 82%; animation-delay: 4.5s; }
.section0 .grid-line.horizontal:nth-child(11) { top: 90%; animation-delay: 5s; }
.section0 .grid-line.horizontal:nth-child(12) { top: 98%; animation-delay: 5.5s; }

.section0 .grid-line.vertical {
  width: 1px;
  height: 100%;
  animation: verticalFlow 8s ease-in-out infinite;
}

.section0 .grid-line.vertical:nth-child(13) { left: 5%; animation-delay: 0.2s; }
.section0 .grid-line.vertical:nth-child(14) { left: 10%; animation-delay: 0.7s; }
.section0 .grid-line.vertical:nth-child(15) { left: 15%; animation-delay: 1.2s; }
.section0 .grid-line.vertical:nth-child(16) { left: 20%; animation-delay: 1.7s; }
.section0 .grid-line.vertical:nth-child(17) { left: 25%; animation-delay: 2.2s; }
.section0 .grid-line.vertical:nth-child(18) { left: 30%; animation-delay: 2.7s; }
.section0 .grid-line.vertical:nth-child(19) { left: 75%; animation-delay: 3.2s; }
.section0 .grid-line.vertical:nth-child(20) { left: 80%; animation-delay: 3.7s; }
.section0 .grid-line.vertical:nth-child(21) { left: 85%; animation-delay: 4.2s; }
.section0 .grid-line.vertical:nth-child(22) { left: 90%; animation-delay: 4.7s; }
.section0 .grid-line.vertical:nth-child(23) { left: 95%; animation-delay: 5.2s; }

/* 数据流网络 */
.section0 .data-network {
  position: absolute;
  width: 100%;
  height: 100%;
}

.section0 .network-line {
  position: absolute;
  height: 1px;
  background: linear-gradient(90deg, transparent, #00ccff, transparent);
  animation: networkPulse 4s ease-in-out infinite;
  filter: brightness(1.2) drop-shadow(0 0 2px #00bfff);
}

.section0 .network-line:nth-child(1) {
  top: 20%;
  left: 10%;
  width: 30%;
  animation-delay: 0s;
}

.section0 .network-line:nth-child(2) {
  top: 35%;
  right: 20%;
  width: 25%;
  animation-delay: 0.8s;
}

.section0 .network-line:nth-child(3) {
  top: 50%;
  left: 15%;
  width: 40%;
  animation-delay: 1.6s;
}

.section0 .network-line:nth-child(4) {
  top: 65%;
  right: 10%;
  width: 35%;
  animation-delay: 2.4s;
}

.section0 .network-line:nth-child(5) {
  top: 80%;
  left: 25%;
  width: 20%;
  animation-delay: 3.2s;
}

.section0 .network-line:nth-child(6) {
  top: 40%;
  left: 60%;
  width: 25%;
  transform: rotate(45deg);
  animation-delay: 1.2s;
}

.section0 .network-line:nth-child(7) { top: 25%; left: 45%; width: 30%; animation-delay: 0.4s; }
.section0 .network-line:nth-child(8) { top: 55%; right: 30%; width: 35%; animation-delay: 1.8s; }
.section0 .network-line:nth-child(9) { top: 75%; left: 35%; width: 25%; animation-delay: 2.8s; }
.section0 .network-line:nth-child(10) { top: 15%; right: 15%; width: 20%; transform: rotate(-30deg); animation-delay: 2.2s; }
.section0 .network-line:nth-child(11) { top: 45%; left: 5%; width: 30%; transform: rotate(60deg); animation-delay: 3.4s; }
.section0 .network-line:nth-child(12) { top: 85%; right: 5%; width: 40%; animation-delay: 4s; }
.section0 .network-line:nth-child(13) { top: 30%; left: 70%; width: 25%; transform: rotate(-45deg); animation-delay: 1.6s; }
.section0 .network-line:nth-child(14) { top: 60%; left: 50%; width: 35%; animation-delay: 3.6s; }
.section0 .network-line:nth-child(15) { top: 10%; left: 30%; width: 20%; transform: rotate(30deg); animation-delay: 4.4s; }

/* 数据节点 */
.section0 .data-nodes {
  position: absolute;
  width: 100%;
  height: 100%;
}

.section0 .node {
  position: absolute;
  width: 8px;
  height: 8px;
  background: #00ccff;
  border-radius: 50%;
  box-shadow: 
    0 0 10px #00ccff,
    0 0 20px rgba(0, 204, 255, 0.5);
  animation: nodePulse 2s ease-in-out infinite;
  filter: brightness(1.1);
}

.section0 .node:nth-child(odd) {
  animation-delay: 0.5s;
}

/* 数据流动 */
.section0 .data-flow {
  position: absolute;
  width: 100%;
  height: 100%;
}

.section0 .flow-particle {
  position: absolute;
  width: 5px;
  height: 5px;
  background: #00ff99;
  border-radius: 50%;
  box-shadow: 
    0 0 10px #00ff99,
    0 0 18px rgba(0, 255, 153, 0.4);
  animation: flowMovement 6s linear infinite;
  filter: brightness(1.2);
}

.section0 .flow-particle:nth-child(1) {
  animation-delay: 0s;
  left: 10%;
  top: 20%;
}

.section0 .flow-particle:nth-child(2) {
  animation-delay: 1.2s;
  right: 20%;
  top: 35%;
}

.section0 .flow-particle:nth-child(3) {
  animation-delay: 2.4s;
  left: 15%;
  top: 50%;
}

.section0 .flow-particle:nth-child(4) {
  animation-delay: 3.6s;
  right: 10%;
  top: 65%;
}

.section0 .flow-particle:nth-child(5) {
  animation-delay: 4.8s;
  left: 25%;
  top: 80%;
}

/* 工业装卸设备轮廓 */
.section0 .equipment-silhouette {
  position: absolute;
  right: 5%;
  bottom: 10%;
  width: 200px;
  height: 150px;
  opacity: 0.2;
}

.section0 .crane-arm {
  position: absolute;
  bottom: 0;
  right: 50px;
  width: 100px;
  height: 4px;
  background: linear-gradient(90deg, transparent, #4a9eff, transparent);
  transform-origin: right center;
  animation: craneSwing 8s ease-in-out infinite;
  filter: brightness(1.1);
  box-shadow: 0 0 5px rgba(74, 158, 255, 0.2);
}

.section0 .crane-arm::before {
  content: '';
  position: absolute;
  right: 0;
  top: -60px;
  width: 4px;
  height: 60px;
  background: #4a9eff;
  filter: brightness(1.1);
  box-shadow: 0 0 4px rgba(74, 158, 255, 0.2);
}

.section0 .container-blocks {
  position: absolute;
  bottom: 0;
  left: 20px;
  display: flex;
  gap: 8px;
}

.section0 .block {
  width: 20px;
  height: 15px;
  background: linear-gradient(45deg, #666, #999);
  border: 1px solid #4a9eff;
  animation: blockGlow 3s ease-in-out infinite;
  filter: brightness(1.1);
}

.section0 .block:nth-child(even) {
  animation-delay: 1.5s;
}

.section0 .ship-outline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 80px;
  height: 25px;
  border: 2px solid #4a9eff;
  border-radius: 0 0 15px 15px;
  animation: shipBob 4s ease-in-out infinite;
  filter: brightness(1.1);
  box-shadow: 0 0 6px rgba(74, 158, 255, 0.2);
}

/* 数码雨 */
.section0 .digital-rain {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.4;
}

.section0 .rain-column {
  position: absolute;
  top: -100px;
  width: 20px;
  height: 120%;
  animation: rainFall var(--rain-duration, 8s) linear infinite;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* 每列数码雨随机参数 */
.section0 .rain-column:nth-child(1) { --rain-duration: 6s; animation-delay: 0s; }
.section0 .rain-column:nth-child(2) { --rain-duration: 9s; animation-delay: 1.2s; }
.section0 .rain-column:nth-child(3) { --rain-duration: 7s; animation-delay: 2.8s; }
.section0 .rain-column:nth-child(4) { --rain-duration: 10s; animation-delay: 0.5s; }
.section0 .rain-column:nth-child(5) { --rain-duration: 8s; animation-delay: 3.5s; }
.section0 .rain-column:nth-child(6) { --rain-duration: 11s; animation-delay: 1.8s; }
.section0 .rain-column:nth-child(7) { --rain-duration: 7.5s; animation-delay: 4.2s; }
.section0 .rain-column:nth-child(8) { --rain-duration: 9.5s; animation-delay: 2.1s; }

.section0 .rain-char {
  font-family: 'Courier New', monospace;
  font-size: 14px;
  color: #00ff33;
  text-shadow: 
    0 0 8px #00ff33,
    0 0 15px rgba(0, 255, 51, 0.4);
  animation: charGlow 2s ease-in-out infinite;
  filter: brightness(1.1);
}

.section0 .rain-column:nth-child(1) { animation-delay: 0s; }
.section0 .rain-column:nth-child(2) { animation-delay: 1s; }
.section0 .rain-column:nth-child(3) { animation-delay: 2s; }
.section0 .rain-column:nth-child(4) { animation-delay: 3s; }
.section0 .rain-column:nth-child(5) { animation-delay: 4s; }
.section0 .rain-column:nth-child(6) { animation-delay: 5s; }
.section0 .rain-column:nth-child(7) { animation-delay: 6s; }
.section0 .rain-column:nth-child(8) { animation-delay: 7s; }

/* HUD界面元素 */
.section0 .hud-elements {
  position: absolute;
  width: 100%;
  height: 100%;
}

.section0 .hud-corner {
  position: absolute;
  width: 60px;
  height: 60px;
  border: 2px solid #00bfff;
  animation: hudTransform 4s ease-in-out infinite;
  transition: all 0.3s ease;
}

.section0 .hud-corner.top-left {
  top: 8%;
  left: 8%;
  border-right: none;
  border-bottom: none;
  animation: cornerTopLeft 5s ease-in-out infinite;
}

.section0 .hud-corner.top-right {
  top: 8%;
  right: 8%;
  border-left: none;
  border-bottom: none;
  animation: cornerTopRight 5s ease-in-out infinite 1.25s;
}

.section0 .hud-corner.bottom-left {
  bottom: 8%;
  left: 8%;
  border-right: none;
  border-top: none;
  animation: cornerBottomLeft 5s ease-in-out infinite 2.5s;
}

.section0 .hud-corner.bottom-right {
  bottom: 8%;
  right: 8%;
  border-left: none;
  border-top: none;
  animation: cornerBottomRight 5s ease-in-out infinite 3.75s;
}

/* 为每个角添加附加装饰元素 */
.section0 .hud-corner::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #00ffff;
  animation: decorRotate 3s linear infinite;
}

.section0 .hud-corner.top-left::before {
  top: -10px;
  left: -10px;
  border-right: none;
  border-bottom: none;
}

.section0 .hud-corner.top-right::before {
  top: -10px;
  right: -10px;
  border-left: none;
  border-bottom: none;
}

.section0 .hud-corner.bottom-left::before {
  bottom: -10px;
  left: -10px;
  border-right: none;
  border-top: none;
}

.section0 .hud-corner.bottom-right::before {
  bottom: -10px;
  right: -10px;
  border-left: none;
  border-top: none;
}

.section0 .scan-line {
  position: absolute;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent, #00ccff, transparent);
  filter: blur(3px) brightness(1.3); /* 调降虚化和亮度 */
  animation: scanMove 4s linear infinite;
  box-shadow: 0 0 6px rgba(0, 204, 255, 0.3);
}

/* 数据显示面板 */
.section0 .data-panels {
  position: absolute;
  width: 100%;
  height: 100%;
}

.section0 .panel {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.section0 .left-panel {
  top: 30%;
  left: 5%;
}

.section0 .panel-line {
  width: 65px;
  height: 2px;
  background: #00ff99;
  animation: panelFlicker 2s ease-in-out infinite;
  filter: brightness(1.1);
  box-shadow: 0 0 5px rgba(0, 255, 153, 0.3);
}

.section0 .panel-line:nth-child(2) { animation-delay: 0.5s; }
.section0 .panel-line:nth-child(3) { animation-delay: 1s; }
.section0 .panel-line:nth-child(4) { animation-delay: 1.5s; }

.section0 .right-panel {
  top: 60%;
  right: 5%;
  flex-direction: row;
}

.section0 .panel-dot {
  width: 6px;
  height: 6px;
  background: #ff7700;
  border-radius: 50%;
  animation: dotBlink 1.5s ease-in-out infinite;
  filter: brightness(1.2);
  box-shadow: 
    0 0 6px #ff7700,
    0 0 10px rgba(255, 119, 0, 0.3);
}

.section0 .panel-dot:nth-child(2) { animation-delay: 0.3s; }
.section0 .panel-dot:nth-child(3) { animation-delay: 0.6s; }
.section0 .panel-dot:nth-child(4) { animation-delay: 0.9s; }
.section0 .panel-dot:nth-child(5) { animation-delay: 1.2s; }
.section0 .panel-dot:nth-child(6) { animation-delay: 1.5s; }

/* 卫星系统 */
.section0 .satellite-system {
  position: absolute;
  top: 25%; /* 往下移动 */
  left: 80%; /* 更靠右，部分延伸到屏幕外 */
  width: 800px; /* 放大2倍 */
  height: 800px; /* 放大2倍 */
  opacity: 0.8;
  filter: blur(0px) brightness(1.1); /* 调降亮度 */
}

.section0 .satellite-core {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 32px; /* 放大2倍 */
  height: 32px; /* 放大2倍 */
  background: radial-gradient(circle, #0088ff, #0066cc);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 
    0 0 40px #0088ff,
    0 0 70px rgba(0, 136, 255, 0.6);
  animation: corePulse 2.8s ease-in-out infinite; /* 调整核心脉冲速度 */
}

.section0 .orbit {
  position: absolute;
  top: 50%;
  left: 50%;
  border: 1px solid rgba(0, 136, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.section0 .inner-orbit {
  width: 180px; /* 放大2倍 */
  height: 180px; /* 放大2倍 */
  animation: orbitRotate1 7.3s linear infinite; /* 非整数秒数 */
}

.section0 .middle-orbit {
  width: 300px; /* 放大2倍 */
  height: 300px; /* 放大2倍 */
  animation: orbitRotate2 11.7s linear infinite reverse; /* 非整数秒数 */
}

.section0 .outer-orbit {
  width: 440px; /* 放大2倍 */
  height: 440px; /* 放大2倍 */
  animation: orbitRotate3 15.1s linear infinite; /* 非整数秒数 */
}

.section0 .satellite {
  position: absolute;
  width: 24px; /* 放大2倍 */
  height: 24px; /* 放大2倍 */
  background: #0088ff;
  border-radius: 50%;
  box-shadow: 
    0 0 36px #0088ff,
    0 0 60px rgba(0, 136, 255, 0.6);
  animation: satellitePulse 2s ease-in-out infinite;
  filter: blur(0.8px);
}

/* 内层卫星位置 */
.section0 .sat-1 {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background: #0077ff;
  box-shadow: 
    0 0 15px #0077ff,
    0 0 25px rgba(0, 119, 255, 0.5);
  animation: satellitePulse 1.8s ease-in-out infinite;
}

.section0 .sat-2 {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background: #0077ff;
  box-shadow: 
    0 0 15px #0077ff,
    0 0 25px rgba(0, 119, 255, 0.5);
  animation: satellitePulse 2.4s ease-in-out infinite 0.7s;
}

/* 中层卫星位置 */
.section0 .sat-3 {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background: #0099ff;
  box-shadow: 
    0 0 18px #0099ff,
    0 0 30px rgba(0, 153, 255, 0.6);
  animation: satellitePulse 2.1s ease-in-out infinite;
}

.section0 .sat-4 {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background: #0099ff;
  box-shadow: 
    0 0 18px #0099ff,
    0 0 30px rgba(0, 153, 255, 0.6);
  animation: satellitePulse 1.6s ease-in-out infinite 0.5s;
}

.section0 .sat-5 {
  bottom: 0;
  left: 20%;
  background: #0099ff;
  box-shadow: 
    0 0 18px #0099ff,
    0 0 30px rgba(0, 153, 255, 0.6);
  animation: satellitePulse 2.7s ease-in-out infinite 1.1s;
}

/* 外层卫星位置 */
.section0 .sat-6 {
  top: 10%;
  right: 10%;
  background: #00aaff;
  box-shadow: 
    0 0 20px #00aaff,
    0 0 35px rgba(0, 170, 255, 0.7);
  animation: satellitePulse 1.9s ease-in-out infinite;
}

.section0 .sat-7 {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background: #00aaff;
  box-shadow: 
    0 0 20px #00aaff,
    0 0 35px rgba(0, 170, 255, 0.7);
  animation: satellitePulse 2.3s ease-in-out infinite 0.3s;
}

.section0 .sat-8 {
  bottom: 10%;
  right: 10%;
  background: #00aaff;
  box-shadow: 
    0 0 20px #00aaff,
    0 0 35px rgba(0, 170, 255, 0.7);
  animation: satellitePulse 2.6s ease-in-out infinite 0.8s;
}

.section0 .sat-9 {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  background: #00aaff;
  box-shadow: 
    0 0 20px #00aaff,
    0 0 35px rgba(0, 170, 255, 0.7);
  animation: satellitePulse 1.7s ease-in-out infinite 1.3s;
}




/* Section0 动画添加 */
@keyframes networkPulse {
  0%, 100% {
    opacity: 0.3;
    transform: scaleX(1);
  }
  50% {
    opacity: 0.8;
    transform: scaleX(1.1);
  }
}

@keyframes nodePulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
  }
}

@keyframes flowMovement {
  0% {
    transform: translateX(0) translateY(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateX(300px) translateY(-50px);
    opacity: 0;
  }
}

@keyframes craneSwing {
  0%, 100% {
    transform: rotate(-5deg);
  }
  50% {
    transform: rotate(5deg);
  }
}

@keyframes blockGlow {
  0%, 100% {
    box-shadow: 0 0 5px rgba(74, 158, 255, 0.3);
  }
  50% {
    box-shadow: 0 0 15px rgba(74, 158, 255, 0.8);
  }
}

@keyframes gridPulse {
  0%, 100% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.8;
  }
}

@keyframes rainFall {
  0% {
    transform: translateY(-100px);
  }
  100% {
    transform: translateY(100vh);
  }
}

@keyframes charGlow {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

@keyframes shipBob {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes cornerTopLeft {
  0% {
    opacity: 0.4;
    border-color: #00bfff;
    transform: scale(1) rotate(0deg);
  }
  25% {
    opacity: 1;
    border-color: #00ffff;
    transform: scale(1.1) rotate(0deg);
  }
  50% {
    opacity: 0.8;
    border-color: #ff6b00;
    transform: scale(1) rotate(45deg);
  }
  75% {
    opacity: 1;
    border-color: #00ff88;
    transform: scale(0.9) rotate(0deg);
  }
  100% {
    opacity: 0.4;
    border-color: #00bfff;
    transform: scale(1) rotate(0deg);
  }
}

@keyframes cornerTopRight {
  0% {
    opacity: 0.4;
    border-color: #00ff88;
    transform: scale(1) translateX(0);
  }
  33% {
    opacity: 1;
    border-color: #ff6b00;
    transform: scale(1.15) translateX(-5px);
  }
  66% {
    opacity: 0.7;
    border-color: #00bfff;
    transform: scale(0.85) translateX(5px);
  }
  100% {
    opacity: 0.4;
    border-color: #00ff88;
    transform: scale(1) translateX(0);
  }
}

@keyframes cornerBottomLeft {
  0% {
    opacity: 0.4;
    border-color: #ff6b00;
    transform: scale(1) skew(0deg);
  }
  40% {
    opacity: 1;
    border-color: #00ffff;
    transform: scale(1.2) skew(5deg);
  }
  80% {
    opacity: 0.6;
    border-color: #00ff88;
    transform: scale(0.8) skew(-5deg);
  }
  100% {
    opacity: 0.4;
    border-color: #ff6b00;
    transform: scale(1) skew(0deg);
  }
}

@keyframes cornerBottomRight {
  0% {
    opacity: 0.4;
    border-color: #00bfff;
    transform: scale(1) translateY(0);
  }
  30% {
    opacity: 1;
    border-color: #00ff88;
    transform: scale(1.3) translateY(-8px);
  }
  60% {
    opacity: 0.5;
    border-color: #ff6b00;
    transform: scale(0.7) translateY(3px);
  }
  100% {
    opacity: 0.4;
    border-color: #00bfff;
    transform: scale(1) translateY(0);
  }
}

@keyframes decorRotate {
  0% {
    transform: rotate(0deg);
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: rotate(360deg);
    opacity: 0.5;
  }
}

@keyframes verticalFlow {
  0% {
    opacity: 0.2;
    background: linear-gradient(0deg, transparent, rgba(0, 191, 255, 0.4), transparent);
    transform: scaleY(1);
  }
  25% {
    opacity: 0.8;
    background: linear-gradient(0deg, transparent, rgba(0, 255, 255, 0.6), transparent);
    transform: scaleY(1.1);
  }
  50% {
    opacity: 0.5;
    background: linear-gradient(0deg, transparent, rgba(255, 107, 0, 0.5), transparent);
    transform: scaleY(0.9) translateX(2px);
  }
  75% {
    opacity: 0.9;
    background: linear-gradient(0deg, transparent, rgba(0, 255, 136, 0.7), transparent);
    transform: scaleY(1.05) translateX(-2px);
  }
  100% {
    opacity: 0.2;
    background: linear-gradient(0deg, transparent, rgba(0, 191, 255, 0.4), transparent);
    transform: scaleY(1);
  }
}

@keyframes hudPulse {
  0%, 100% {
    opacity: 0.4;
    border-color: #00bfff;
  }
  50% {
    opacity: 1;
    border-color: #00ffff;
  }
}

@keyframes scanMove {
  0% {
    top: 0;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    top: 100%;
    opacity: 0;
  }
}

@keyframes panelFlicker {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

@keyframes dotBlink {
  0%, 50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

/* 卫星系统动画 */
@keyframes corePulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    box-shadow: 
      0 0 15px #00ffff,
      0 0 30px rgba(0, 255, 255, 0.5);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    box-shadow: 
      0 0 25px #00ffff,
      0 0 50px rgba(0, 255, 255, 0.8);
  }
}

@keyframes orbitRotate1 {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes orbitRotate2 {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(-360deg);
  }
}

@keyframes orbitRotate3 {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes satellitePulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.3);
    opacity: 1;
  }
}

@keyframes matrixFall {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(100%);
  }
}

@keyframes charGlow {
  0%, 100% {
    opacity: 0.8;
    text-shadow: 0 0 8px rgba(0, 200, 255, 0.8);
  }
  50% {
    opacity: 1;
    text-shadow: 0 0 12px rgba(0, 200, 255, 1), 0 0 20px rgba(0, 200, 255, 0.6);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section1 {
  // position: relative;
  top: 100%;

  /* 科技感背景样式 */
  .tech-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(ellipse at bottom right, #1a1f3a 0%, #0a0e27 40%, #050714 100%);
    overflow: hidden;
  }

  /* 动态网格背景 */
  .grid-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image:
      linear-gradient(90deg, rgba(0, 255, 255, 0.03) 1px, transparent 1px);
    background-size: 100px 100px;
    animation: gridPulse 4s ease-in-out infinite;
  }

  /* 多层粒子效果 */
  .particle-layer {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .particle {
    position: absolute;
    width: 4px;
    height: 4px;
    background: rgba(0, 255, 255, 0.8);
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
  }

  .p1 { left: 10%; animation: particleRise 8s linear infinite; }
  .p2 { left: 25%; animation: particleRise 10s linear infinite 1s; }
  .p3 { left: 40%; animation: particleRise 12s linear infinite 2s; }
  .p4 { left: 55%; animation: particleRise 9s linear infinite 0.5s; }
  .p5 { left: 70%; animation: particleRise 11s linear infinite 1.5s; }
  .p6 { left: 85%; animation: particleRise 13s linear infinite 3s; }
  .p7 { left: 30%; animation: particleRise 10s linear infinite 2.5s; }
  .p8 { left: 60%; animation: particleRise 8s linear infinite 3.5s; }
  .p9 { left: 5%; animation: particleRise 7s linear infinite 4s; }
  .p10 { left: 45%; animation: particleRise 9s linear infinite 4.5s; }
  .p11 { left: 75%; animation: particleRise 6s linear infinite 5s; }
  .p12 { left: 90%; animation: particleRise 11s linear infinite 5.5s; }

  /* 数据流效果 - 从下往上 */
  .data-streams {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .stream {
    position: absolute;
    width: 2px;
    background: linear-gradient(0deg,
      transparent,
      rgba(0, 255, 255, 0.4),
      rgba(0, 150, 255, 0.8),
      rgba(255, 255, 255, 1),
      transparent);
  }

  .stream-1 {
    left: 15%;
    height: 200px;
    animation: streamRise 4s linear infinite;
  }

  .stream-2 {
    left: 35%;
    height: 150px;
    animation: streamRise 3.5s linear infinite 0.5s;
  }

  .stream-3 {
    left: 50%;
    height: 180px;
    animation: streamRise 5s linear infinite 1s;
  }

  .stream-4 {
    left: 65%;
    height: 160px;
    animation: streamRise 4.5s linear infinite 1.5s;
  }

  .stream-5 {
    left: 80%;
    height: 140px;
    animation: streamRise 3s linear infinite 2s;
  }

  .stream-6 {
    left: 90%;
    height: 120px;
    animation: streamRise 4s linear infinite 2.5s;
  }

  .stream-7 {
    left: 5%;
    height: 170px;
    animation: streamRise 3.8s linear infinite 3s;
  }

  /* 几何图形背景层 */
  .geometric-shapes {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .shape {
    position: absolute;
    border: 1px solid rgba(0, 255, 255, 0.2);
  }

  .triangle {
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 25px solid rgba(0, 255, 255, 0.1);
    animation: shapeFloat 8s ease-in-out infinite;
  }

  .triangle.tri-1 {
    top: 20%;
    left: 10%;
    animation-delay: 0s;
  }

  .triangle.tri-2 {
    top: 60%;
    left: 80%;
    animation-delay: 2s;
  }

  .triangle.tri-3 {
    top: 40%;
    left: 60%;
    animation-delay: 4s;
  }

  .circle {
    border-radius: 50%;
    background: rgba(0, 255, 255, 0.05);
    animation: shapeRotate 12s linear infinite;
  }

  .circle.circ-1 {
    top: 30%;
    left: 30%;
    width: 40px;
    height: 40px;
  }

  .circle.circ-2 {
    top: 70%;
    left: 15%;
    width: 60px;
    height: 60px;
    animation-delay: 3s;
  }

  .diamond {
    width: 20px;
    height: 20px;
    background: rgba(0, 255, 255, 0.1);
    transform: rotate(45deg);
    animation: shapePulse 6s ease-in-out infinite;
  }

  .diamond.dia-1 {
    top: 15%;
    left: 70%;
    animation-delay: 1s;
  }

  .diamond.dia-2 {
    top: 80%;
    left: 50%;
    animation-delay: 3s;
  }

  /* 光束扫描效果 */
  .light-beams {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .beam {
    position: absolute;
    background: linear-gradient(90deg,
      transparent,
      rgba(0, 255, 255, 0.4),
      transparent);
    animation: beamSweep 8s ease-in-out infinite;
  }

  .beam-diagonal-1 {
    top: 20%;
    left: 0;
    width: 300px;
    height: 2px;
    transform: rotate(30deg);
    animation-delay: 0s;
  }

  .beam-diagonal-2 {
    top: 70%;
    right: 0;
    width: 250px;
    height: 2px;
    transform: rotate(-45deg);
    animation-delay: 4s;
  }

  .beam-horizontal {
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    animation-delay: 2s;
  }

  /* 波纹扩散效果 */
  .ripple-effects {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .ripple {
    position: absolute;
    border: 2px solid rgba(0, 255, 255, 0.3);
    border-radius: 50%;
    animation: rippleExpand 6s ease-out infinite;
  }

  .ripple-1 {
    top: 25%;
    left: 25%;
    width: 10px;
    height: 10px;
    animation-delay: 0s;
  }

  .ripple-2 {
    top: 60%;
    left: 70%;
    width: 15px;
    height: 15px;
    animation-delay: 2s;
  }

  .ripple-3 {
    top: 80%;
    left: 30%;
    width: 12px;
    height: 12px;
    animation-delay: 4s;
  }

  /* 代码雨背景 */
  .code-rain {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    opacity: 0.3;
  }

  .code-column {
    position: absolute;
    color: rgba(0, 255, 255, 0.6);
    font-family: 'Courier New', monospace;
    font-size: 12px;
    animation: codeRain 15s linear infinite;
  }

  .code-column.cc-1 {
    left: 20%;
    animation-delay: 0s;
  }

  .code-column.cc-2 {
    left: 40%;
    animation-delay: 3s;
  }

  .code-column.cc-3 {
    left: 60%;
    animation-delay: 6s;
  }

  .code-column.cc-4 {
    left: 80%;
    animation-delay: 9s;
  }

  .code-column.cc-5 {
    left: 90%;
    animation-delay: 12s;
  }

  /* 能量脉冲网络 */
  .energy-network {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .network-node {
    position: absolute;
    width: 8px;
    height: 8px;
    background: rgba(0, 255, 255, 0.8);
    border-radius: 50%;
    animation: networkPulse 4s ease-in-out infinite;
    box-shadow: 0 0 15px rgba(0, 255, 255, 0.6);
  }

  .network-node.node-1 {
    top: 30%;
    left: 20%;
    animation-delay: 0s;
  }

  .network-node.node-2 {
    top: 30%;
    left: 70%;
    animation-delay: 1s;
  }

  .network-node.node-3 {
    top: 70%;
    left: 20%;
    animation-delay: 2s;
  }

  .network-node.node-4 {
    top: 70%;
    left: 70%;
    animation-delay: 3s;
  }

  .network-connection {
    position: absolute;
    height: 1px;
    background: linear-gradient(90deg,
      rgba(0, 255, 255, 0.6),
      transparent,
      rgba(0, 255, 255, 0.6));
    animation: connectionPulse 5s ease-in-out infinite;
  }

  .network-connection.conn-1 {
    top: 30%;
    left: 20%;
    width: 50%;
    animation-delay: 0.5s;
  }

  .network-connection.conn-2 {
    top: 50%;
    left: 20%;
    width: 1px;
    height: 20%;
    transform: rotate(90deg);
    animation-delay: 1.5s;
  }

  .network-connection.conn-3 {
    top: 70%;
    left: 20%;
    width: 50%;
    animation-delay: 2.5s;
  }

  /* 右侧科技元素 */
  .tech-elements-right {
    position: absolute;
    right: 16%;
    top: 50%;
    transform: translateY(-50%) scale(4);
    width: 350px;
    height: 700px;
  }

  /* 主控制面板 */
  .control-panel {
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: 200px;
  }

  /* 雷达扫描器 */
  .radar-scanner {
    position: relative;
    width: 150px;
    height: 150px;
    margin: 0 auto;
  }

  .radar-circle {
    position: absolute;
    border: 1px solid rgba(0, 150, 255, 0.3);
    border-radius: 50%;
    animation: radarPulse 3s ease-in-out infinite;
  }

  .radar-circle.outer {
    width: 150px;
    height: 150px;
    top: 0;
    left: 0;
  }

  .radar-circle.middle {
    width: 100px;
    height: 100px;
    top: 25px;
    left: 25px;
    animation-delay: 0.5s;
  }

  .radar-circle.inner {
    width: 50px;
    height: 50px;
    top: 50px;
    left: 50px;
    animation-delay: 1s;
  }

  .radar-sweep {
    position: absolute;
    width: 75px;
    height: 2px;
    background: linear-gradient(90deg, rgba(0, 255, 255, 0.8), transparent);
    top: 74px;
    left: 75px;
    transform-origin: left center;
    animation: radarSweep 4s linear infinite;
  }

  .radar-blip {
    position: absolute;
    width: 6px;
    height: 6px;
    background: rgba(0, 255, 255, 0.9);
    border-radius: 50%;
    animation: blipPulse 2s ease-in-out infinite;
  }

  .radar-blip.blip-1 {
    top: 30px;
    left: 80px;
    animation-delay: 0s;
  }

  .radar-blip.blip-2 {
    top: 90px;
    left: 40px;
    animation-delay: 0.7s;
  }

  .radar-blip.blip-3 {
    top: 60px;
    left: 110px;
    animation-delay: 1.4s;
  }

  /* 全息投影仪 */
  .hologram-projector {
    position: absolute;
    top: 170px;
    left: 20px;
    width: 140px;
    height: 100px;
  }

  .hologram-base {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 10px;
    background: linear-gradient(90deg, rgba(0, 255, 255, 0.5), rgba(0, 255, 255, 0.8), rgba(0, 255, 255, 0.5));
    border-radius: 5px;
    animation: baseGlow 2s ease-in-out infinite;
  }

  .hologram-beam {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 40px;
    background: linear-gradient(180deg, rgba(0, 255, 255, 0.8), transparent);
    animation: beamFlicker 1.5s ease-in-out infinite;
  }

  .hologram-content {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 50px;
  }

  .holo-layer {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0, 255, 255, 0.4);
    animation: holoLayerFloat 3s ease-in-out infinite;
  }

  .holo-layer.layer-1 {
    transform: translateY(0px);
    animation-delay: 0s;
  }

  .holo-layer.layer-2 {
    transform: translateY(-5px);
    animation-delay: 0.5s;
  }

  .holo-layer.layer-3 {
    transform: translateY(-10px);
    animation-delay: 1s;
  }

  .holo-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: rgba(0, 255, 255, 0.8);
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    animation: textGlitch 2s ease-in-out infinite;
  }

  /* 数据流显示器 */
  .data-stream-display {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 160px;
    height: 140px;
    background: rgba(0, 20, 40, 0.3);
    border: 1px solid rgba(0, 255, 255, 0.2);
    border-radius: 8px;
    overflow: hidden;
  }

  /* 矩阵雨效果 */
  .matrix-rain {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .matrix-column {
    position: absolute;
    width: 2px;
    height: 100%;
    background: linear-gradient(180deg,
      transparent,
      rgba(0, 150, 255, 0.8),
      rgba(0, 255, 255, 0.4),
      transparent);
    animation: matrixFall 2s linear infinite;
  }

  .matrix-column.col-1 {
    left: 20%;
    animation-delay: 0s;
  }

  .matrix-column.col-2 {
    left: 40%;
    animation-delay: 0.4s;
  }

  .matrix-column.col-3 {
    left: 60%;
    animation-delay: 0.8s;
  }

  .matrix-column.col-4 {
    left: 80%;
    animation-delay: 1.2s;
  }

  .matrix-column.col-5 {
    left: 100%;
    animation-delay: 1.6s;
  }

  /* 电路板图案 */
  .circuit-board {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .circuit-path {
    position: absolute;
    background: rgba(0, 255, 255, 0.3);
    animation: circuitPulse 3s ease-in-out infinite;
  }

  .circuit-path.path-h1 {
    top: 30%;
    left: 10%;
    width: 80%;
    height: 1px;
  }

  .circuit-path.path-h2 {
    top: 70%;
    left: 10%;
    width: 80%;
    height: 1px;
    animation-delay: 1.5s;
  }

  .circuit-path.path-v1 {
    top: 10%;
    left: 30%;
    width: 1px;
    height: 80%;
    animation-delay: 0.75s;
  }

  .circuit-path.path-v2 {
    top: 10%;
    left: 70%;
    width: 1px;
    height: 80%;
    animation-delay: 2.25s;
  }

  .circuit-node {
    position: absolute;
    width: 6px;
    height: 6px;
    background: rgba(0, 255, 255, 0.8);
    border-radius: 50%;
    animation: nodePulse 2s ease-in-out infinite;
  }

  .circuit-node.node-1 {
    top: 27%;
    left: 27%;
    animation-delay: 0s;
  }

  .circuit-node.node-2 {
    top: 27%;
    left: 67%;
    animation-delay: 0.5s;
  }

  .circuit-node.node-3 {
    top: 67%;
    left: 27%;
    animation-delay: 1s;
  }

  .circuit-node.node-4 {
    top: 67%;
    left: 67%;
    animation-delay: 1.5s;
  }

  /* 量子计算可视化 */
  .quantum-visualizer {
    position: absolute;
    top: 320px;
    left: 50px;
    width: 200px;
    height: 140px;
  }

  .qubit-container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .qubit {
    position: absolute;
    width: 60px;
    height: 60px;
    top: 50%;
    transform: translateY(-50%);
  }

  .qubit.q1 {
    left: 20px;
  }

  .qubit.q2 {
    right: 20px;
  }

  .qubit-core {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
    animation: coreGlow 2s ease-in-out infinite;
  }

  .qubit-orbit {
    position: absolute;
    top: 50%;
    left: 50%;
    border: 1px solid rgba(0, 255, 255, 0.4);
    border-radius: 50%;
  }

  .qubit-orbit.orbit-x {
    width: 40px;
    height: 40px;
    margin: -20px 0 0 -20px;
    animation: orbitX 3s linear infinite;
  }

  .qubit-orbit.orbit-y {
    width: 50px;
    height: 50px;
    margin: -25px 0 0 -25px;
    animation: orbitY 4s linear infinite;
  }

  .qubit-orbit.orbit-z {
    width: 60px;
    height: 60px;
    margin: -30px 0 0 -30px;
    animation: orbitZ 5s linear infinite;
  }

  .entanglement-line {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100px;
    height: 2px;
    background: linear-gradient(90deg,
      rgba(0, 255, 255, 0.6),
      rgba(0, 150, 255, 0.8),
      rgba(0, 255, 255, 0.6));
    transform: translate(-50%, -50%);
    animation: entanglementFlow 2s ease-in-out infinite;
  }

  .energy-waves {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 20px;
  }

  .energy-waves .wave {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg,
      transparent,
      rgba(0, 255, 255, 0.3),
      transparent);
    animation: energyWave 3s ease-in-out infinite;
  }

  .energy-waves .wave-1 {
    animation-delay: 0s;
  }

  .energy-waves .wave-2 {
    animation-delay: 1s;
  }

  .energy-waves .wave-3 {
    animation-delay: 2s;
  }

  /* DNA螺旋结构 */
  .dna-helix {
    position: absolute;
    bottom: 80px;
    right: 30px;
    width: 120px;
    height: 180px;
  }

  .helix-strand {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .helix-strand.strand-1 {
    animation: helixRotate1 4s linear infinite;
  }

  .helix-strand.strand-2 {
    animation: helixRotate2 4s linear infinite;
  }

  .base-pair {
    position: absolute;
    width: 4px;
    height: 4px;
    background: rgba(0, 255, 255, 0.8);
    border-radius: 50%;
  }

  .helix-strand.strand-1 .base-pair.bp-1 {
    top: 20%;
    left: 20%;
  }

  .helix-strand.strand-1 .base-pair.bp-2 {
    top: 40%;
    left: 80%;
  }

  .helix-strand.strand-1 .base-pair.bp-3 {
    top: 60%;
    left: 20%;
  }

  .helix-strand.strand-1 .base-pair.bp-4 {
    top: 80%;
    left: 80%;
  }

  .helix-strand.strand-2 .base-pair.bp-1 {
    top: 20%;
    left: 80%;
  }

  .helix-strand.strand-2 .base-pair.bp-2 {
    top: 40%;
    left: 20%;
  }

  .helix-strand.strand-2 .base-pair.bp-3 {
    top: 60%;
    left: 80%;
  }

  .helix-strand.strand-2 .base-pair.bp-4 {
    top: 80%;
    left: 20%;
  }

  /* 附加装饰元素 */
  .tech-decorations {
    position: absolute;
    top: 180px;
    right: 40px;
    width: 100px;
    height: 120px;
  }

  /* 六边形网格 */
  .hex-grid {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
  }

  .hexagon {
    position: absolute;
    width: 20px;
    height: 20px;
    background: transparent;
    border: 1px solid rgba(0, 255, 255, 0.4);
    transform: rotate(45deg);
    animation: hexGlow 3s ease-in-out infinite;
  }

  .hexagon.hex-1 {
    top: 10px;
    left: 10px;
    animation-delay: 0s;
  }

  .hexagon.hex-2 {
    top: 10px;
    left: 40px;
    animation-delay: 1s;
  }

  .hexagon.hex-3 {
    top: 30px;
    left: 25px;
    animation-delay: 2s;
  }

  /* 数字化指示器 */
  .digital-indicators {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
  }

  .indicator {
    position: absolute;
    width: 80px;
    height: 3px;
    background: linear-gradient(90deg,
      transparent,
      rgba(0, 255, 255, 0.6),
      transparent);
    animation: indicatorScan 2s ease-in-out infinite;
  }

  .indicator.ind-1 {
    top: 10px;
    left: 0;
    animation-delay: 0s;
  }

  .indicator.ind-2 {
    top: 25px;
    left: 10px;
    animation-delay: 0.7s;
  }

  .indicator.ind-3 {
    top: 40px;
    left: 5px;
    animation-delay: 1.4s;
  }

  /* 左下角装饰 */
  .corner-decoration {
    position: absolute;
    bottom: 10%;
    left: 10%;
    width: 150px;
    height: 150px;
  }

  .corner-line {
    position: absolute;
    background: rgba(0, 255, 255, 0.5);
  }

  .line-1 {
    bottom: 0;
    left: 0;
    width: 100px;
    height: 2px;
    animation: lineExtend 2s ease-in-out infinite;
  }

  .line-2 {
    bottom: 0;
    left: 0;
    width: 2px;
    height: 100px;
    animation: lineExtend 2s ease-in-out infinite 0.5s;
  }

  .corner-dot {
    position: absolute;
    bottom: -5px;
    left: -5px;
    width: 10px;
    height: 10px;
    background: rgba(0, 255, 255, 1);
    border-radius: 50%;
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.8);
    animation: dotPulse 2s ease-in-out infinite;
  }

  /* 文字效果 */
  .fade-in-text {
    animation: fadeInUp 1s ease-out;
  }

  .fade-in-text-delay {
    animation: fadeInUp 1s ease-out 0.5s both;
  }

  .elButton {
    position: absolute;
    top: 60%;
    left: 15%;
    background-color: #d91724 !important;
    color: white !important;
    border: none !important;
    width: 12% !important;
    height: 6% !important;
    font-size: calc(100vw * 20 / 1920) !important;
    animation: fadeInUp 1s ease-out 1s both;
    overflow: hidden;
    z-index: 10;
  }

  .elButton::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
  }

  .elButton:hover::before {
    left: 100%;
  }

  .elButton:hover {
    transform: scale(1.1);
    transition: transform 0.3s ease-in-out;
    box-shadow: 0 0 30px rgba(217, 23, 36, 0.8);
  }
}

/* 动画定义 */
@keyframes gridPulse {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.6;
  }
}

@keyframes particleRise {
  0% {
    bottom: -10px;
    opacity: 0;
    transform: translateX(0) scale(0);
  }
  10% {
    opacity: 1;
    transform: translateX(10px) scale(1);
  }
  30% {
    transform: translateX(-10px) scale(1.2);
  }
  60% {
    transform: translateX(15px) scale(0.8);
  }
  90% {
    opacity: 1;
    transform: translateX(-5px) scale(0.6);
  }
  100% {
    bottom: 110%;
    opacity: 0;
    transform: translateX(0) scale(0);
  }
}

@keyframes streamRise {
  0% {
    bottom: -200px;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    bottom: 110%;
    opacity: 0;
  }
}

/* 雷达相关动画 */
@keyframes radarPulse {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
  }
}

@keyframes radarSweep {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes blipPulse {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.5);
    box-shadow: 0 0 15px rgba(0, 255, 255, 0.8);
  }
}

/* 全息投影动画 */
@keyframes baseGlow {
  0%, 100% {
    opacity: 0.7;
    box-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
  }
  50% {
    opacity: 1;
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.8);
  }
}

@keyframes beamFlicker {
  0%, 100% {
    opacity: 0.6;
  }
  25% {
    opacity: 0.9;
  }
  50% {
    opacity: 0.3;
  }
  75% {
    opacity: 0.8;
  }
}

@keyframes holoLayerFloat {
  0%, 100% {
    opacity: 0.4;
    transform: translateY(0px);
  }
  50% {
    opacity: 0.8;
    transform: translateY(-2px);
  }
}

@keyframes textGlitch {
  0%, 90%, 100% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
  5% {
    opacity: 0.8;
    transform: translate(-48%, -50%);
  }
  15% {
    opacity: 0.9;
    transform: translate(-52%, -50%);
  }
}

/* 波浪光效动画 - 从上到下 */
@keyframes waveDown {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(200%);
  }
}

/* 电路板动画 */
@keyframes circuitPulse {
  0%, 100% {
    opacity: 0.3;
    box-shadow: 0 0 5px rgba(0, 255, 255, 0.3);
  }
  50% {
    opacity: 0.8;
    box-shadow: 0 0 15px rgba(0, 255, 255, 0.7);
  }
}

@keyframes nodePulse {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.3);
    box-shadow: 0 0 12px rgba(0, 255, 255, 0.8);
  }
}

/* 量子计算动画 */
@keyframes coreGlow {
  0%, 100% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.2);
    box-shadow: 0 0 25px rgba(255, 255, 255, 1);
  }
}

@keyframes orbitX {
  0% {
    transform: rotateX(0deg);
  }
  100% {
    transform: rotateX(360deg);
  }
}

@keyframes orbitY {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}

@keyframes orbitZ {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}

@keyframes entanglementFlow {
  0%, 100% {
    opacity: 0.6;
    transform: translate(-50%, -50%) scaleX(1);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scaleX(1.1);
    box-shadow: 0 0 15px rgba(0, 255, 255, 0.8);
  }
}

@keyframes energyWave {
  0%, 100% {
    opacity: 0.3;
    transform: translateX(-100%);
  }
  50% {
    opacity: 0.8;
    transform: translateX(100%);
  }
}

/* DNA螺旋动画 */
@keyframes helixRotate1 {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}

@keyframes helixRotate2 {
  0% {
    transform: rotateZ(0deg) scaleX(-1);
  }
  100% {
    transform: rotateZ(360deg) scaleX(-1);
  }
}

/* 装饰元素动画 */
@keyframes hexGlow {
  0%, 100% {
    opacity: 0.4;
    border-color: rgba(0, 255, 255, 0.4);
    box-shadow: 0 0 5px rgba(0, 255, 255, 0.3);
  }
  50% {
    opacity: 0.8;
    border-color: rgba(0, 255, 255, 0.8);
    box-shadow: 0 0 15px rgba(0, 255, 255, 0.6);
  }
}

@keyframes indicatorScan {
  0%, 100% {
    opacity: 0.4;
    transform: scaleX(0.8);
  }
  50% {
    opacity: 0.9;
    transform: scaleX(1.2);
    box-shadow: 0 0 10px rgba(0, 255, 255, 0.6);
  }
}

/* 背景几何图形动画 */
@keyframes shapeFloat {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
    opacity: 0.7;
  }
}

@keyframes shapeRotate {
  0% {
    transform: rotate(0deg) scale(1);
    opacity: 0.3;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    transform: rotate(360deg) scale(1);
    opacity: 0.3;
  }
}

@keyframes shapePulse {
  0%, 100% {
    transform: rotate(45deg) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: rotate(45deg) scale(1.3);
    opacity: 0.7;
    box-shadow: 0 0 15px rgba(0, 255, 255, 0.5);
  }
}

/* 光束扫描动画 */
@keyframes beamSweep {
  0%, 100% {
    opacity: 0;
    transform: translateX(-100%);
  }
  50% {
    opacity: 0.8;
    transform: translateX(0%);
  }
}

/* 波纹扩散动画 */
@keyframes rippleExpand {
  0% {
    width: 10px;
    height: 10px;
    opacity: 0.8;
  }
  100% {
    width: 200px;
    height: 200px;
    opacity: 0;
  }
}

/* 代码雨动画 */
@keyframes codeRain {
  0% {
    top: -50px;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    top: 100%;
    opacity: 0;
  }
}

/* 网络脉冲动画 */
@keyframes networkPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.4;
    box-shadow: 0 0 25px rgba(0, 255, 255, 1);
  }
}

@keyframes connectionPulse {
  0%, 100% {
    opacity: 0.4;
    transform: scaleX(1);
  }
  50% {
    opacity: 0.8;
    transform: scaleX(1.1);
    box-shadow: 0 0 10px rgba(0, 255, 255, 0.6);
  }
}

/* Section6 环形科技动效动画 */
@keyframes coreRingPulse {
  0%, 100% {
    opacity: 0.6;
    transform: translate(-50%, -50%) scale(1);
    border-color: rgba(0, 255, 255, 0.6);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.1);
    border-color: rgba(0, 255, 255, 1);
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.8);
  }
}

@keyframes coreCenterGlow {
  0%, 100% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1);
    box-shadow: 0 0 40px rgba(0, 255, 255, 0.8);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.2);
    box-shadow: 0 0 60px rgba(0, 255, 255, 1);
  }
}

@keyframes ringRotateClockwise {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes ringRotateCounterClockwise {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(-360deg);
  }
}

@keyframes orbitRotation1 {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes orbitRotation2 {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(-360deg);
  }
}

@keyframes orbitRotation3 {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes particleGlow {
  0%, 100% {
    opacity: 0.7;
    transform: translateX(-50%) scale(1);
  }
  50% {
    opacity: 1;
    transform: translateX(-50%) scale(1.3);
    box-shadow: 0 0 25px rgba(0, 255, 255, 1);
  }
}

@keyframes pulseWaveExpand {
  0% {
    width: 80px;
    height: 80px;
    opacity: 0.8;
    border-color: rgba(0, 255, 255, 0.8);
  }
  100% {
    width: 1000px;
    height: 1000px;
    opacity: 0;
    border-color: rgba(0, 255, 255, 0);
  }
}

@keyframes streamOrbitRotate1 {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes streamOrbitRotate2 {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes dotPulse {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.4);
    box-shadow: 0 0 18px rgba(0, 255, 255, 0.9);
  }
}

@keyframes rayRotate {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.4;
  }
}

@keyframes arcRotate {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes titleGlow {
  0%, 100% {
    opacity: 0.9;
    text-shadow:
      0 0 40px rgba(0, 150, 255, 0.8),
      0 0 80px rgba(0, 150, 255, 0.6),
      0 0 120px rgba(0, 150, 255, 0.4);
  }
  50% {
    opacity: 1;
    text-shadow:
      0 0 60px rgba(0, 150, 255, 1),
      0 0 100px rgba(0, 150, 255, 0.8),
      0 0 140px rgba(0, 150, 255, 0.6);
  }
}

@keyframes lineExtend {
  0%, 100% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes dotPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 统一设计右侧科技元素 */
.tech-elements-right {
  position: absolute;
  right: 10%;
  top: 50%;
  transform: translateY(-50%) scale(2.5);
  width: 300px;
  height: 300px;
  z-index: 10;
}

/* 主核心系统 */
.main-core-system {
  position: relative;
  width: 100%;
  height: 100%;
}

.core-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
}

.core-sphere {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80px;
  height: 80px;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(0, 255, 255, 0.8) 0%, rgba(0, 255, 255, 0.2) 70%, transparent 100%);
  border-radius: 50%;
  box-shadow: 0 0 40px rgba(0, 255, 255, 0.6), inset 0 0 20px rgba(0, 255, 255, 0.8);
  animation: corePulse 3s ease-in-out infinite;
}

.core-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  border: 1px solid rgba(0, 255, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.core-ring.ring-1 {
  width: 140px;
  height: 140px;
  animation: ringRotate 6s linear infinite;
}

.core-ring.ring-2 {
  width: 180px;
  height: 180px;
  animation: ringRotate 8s linear infinite reverse;
  opacity: 0.6;
}

.core-ring.ring-3 {
  width: 220px;
  height: 220px;
  animation: ringRotate 10s linear infinite;
  opacity: 0.4;
}

/* 卫星系统 */
.satellite-system {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 250px;
  height: 250px;
  transform: translate(-50%, -50%);
  animation: systemRotate 20s linear infinite;
}

.satellite {
  position: absolute;
  width: 12px;
  height: 12px;
  background: rgba(0, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.8);
}

.satellite.sat-1 {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  animation: satellitePulse 2s ease-in-out infinite;
}

.satellite.sat-2 {
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  animation: satellitePulse 2s ease-in-out infinite 0.5s;
}

.satellite.sat-3 {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  animation: satellitePulse 2s ease-in-out infinite 1s;
}

.satellite.sat-4 {
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  animation: satellitePulse 2s ease-in-out infinite 1.5s;
}

/* 连接线网络 */
.connection-network {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 250px;
  height: 250px;
  transform: translate(-50%, -50%);
}

.conn-line {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 125px;
  height: 1px;
  background: linear-gradient(90deg, rgba(0, 255, 255, 0.8), transparent);
  transform-origin: left center;
}

.conn-line.line-1 {
  transform: rotate(0deg);
  animation: lineFlash 3s linear infinite;
}

.conn-line.line-2 {
  transform: rotate(90deg);
  animation: lineFlash 3s linear infinite 0.75s;
}

.conn-line.line-3 {
  transform: rotate(180deg);
  animation: lineFlash 3s linear infinite 1.5s;
}

.conn-line.line-4 {
  transform: rotate(270deg);
  animation: lineFlash 3s linear infinite 2.25s;
}

/* 数据流系统 */
.data-flow-system {
  position: absolute;
  top: 70%;
  left: 90%;
  width: 280px;
  height: 280px;
  transform: translate(-50%, -50%);
}

.data-particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(0, 255, 255, 0.6);
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(0, 255, 255, 0.6);
}

.data-particle.dp-1 {
  animation: dataOrbit1 4s linear infinite;
}

.data-particle.dp-2 {
  animation: dataOrbit1 4s linear infinite 0.66s;
}

.data-particle.dp-3 {
  animation: dataOrbit1 4s linear infinite 1.33s;
}

.data-particle.dp-4 {
  animation: dataOrbit2 5s linear infinite;
}

.data-particle.dp-5 {
  animation: dataOrbit2 5s linear infinite 1.66s;
}

.data-particle.dp-6 {
  animation: dataOrbit2 5s linear infinite 3.33s;
}

/* 能量场 */
.energy-field {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.field-layer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}

.field-layer.layer-1 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, transparent 40%, rgba(0, 255, 255, 0.05) 70%, transparent 100%);
  animation: fieldExpand 4s ease-in-out infinite;
}

.field-layer.layer-2 {
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, transparent 50%, rgba(0, 255, 255, 0.03) 80%, transparent 100%);
  animation: fieldExpand 4s ease-in-out infinite 2s;
}


/* 新的统一动画 */
@keyframes systemRotate {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

@keyframes satellitePulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.3);
    opacity: 1;
  }
}

@keyframes lineFlash {
  0%, 100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}

@keyframes dataOrbit1 {
  0% {
    transform: rotate(0deg) translateX(120px) rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translateX(120px) rotate(-360deg);
  }
}

@keyframes dataOrbit2 {
  0% {
    transform: rotate(0deg) translateX(100px) rotate(0deg);
  }
  100% {
    transform: rotate(-360deg) translateX(100px) rotate(360deg);
  }
}

@keyframes fieldExpand {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.1;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 0.2;
  }
}

@keyframes corePulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    box-shadow: 0 0 50px rgba(0, 255, 255, 0.6), inset 0 0 25px rgba(0, 255, 255, 0.8);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    box-shadow: 0 0 80px rgba(0, 255, 255, 0.8), inset 0 0 40px rgba(0, 255, 255, 1);
  }
}

@keyframes ringRotate {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

@keyframes beamRotate {
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
}

@keyframes powerBlink {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

@keyframes neuralRotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes synapsePulse {
  0%, 100% {
    opacity: 0.3;
    box-shadow: 0 0 5px rgba(0, 255, 255, 0.5);
  }
  50% {
    opacity: 1;
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.8);
  }
}

@keyframes pulseBeat {
  0%, 100% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
  }
}

@keyframes pointFloat {
  0%, 100% {
    transform: translateZ(0);
  }
  50% {
    transform: translateZ(20px);
  }
}

@keyframes warpExpand {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.2;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.4;
  }
}

@keyframes portalSpin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

@keyframes shieldRotate {
  0% { transform: rotateY(0deg); }
  100% { transform: rotateY(360deg); }
}

@keyframes layerPulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 1;
  }
}

@keyframes arcSpin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

@keyframes energyGlow {
  0%, 100% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1.2);
  }
}

.section2 {
  top: 200%;
  .elButton {
    position: absolute;
    top: 63%;
    left: 44%;
    background-color: #d91724 !important;
    color: white !important;
    border: none !important;
    width: 12% !important;
    height: 6% !important;
    font-size: calc(100vw * 20 / 1920) !important;
    // border-radius: 5%;
  }
}
.section3 {
  top: 300%;
  .elButton {
    position: absolute;
    top: 72%;
    left: 50%;
    background-color: #d91724 !important;
    color: white !important;
    border: none !important;
    width: 12% !important;
    height: 6% !important;
    font-size: calc(100vw * 20 / 1920) !important;
    // border-radius: 5%;
  }
}
.section4 {
  top: 400%;
}
.section5 {
  top: 500%;
  .elButton {
    position: absolute;
    top: 60%;
    left: 15%;
    background-color: #d91724 !important;
    color: white !important;
    border: none !important;
    width: 12% !important;
    height: 6% !important;
    font-size: calc(100vw * 20 / 1920) !important;
    // border-radius: 5%;
  }
}
.section6 {
  top: 600%;

  /* 环形科技背景 */
  .circular-tech-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at center,
      rgba(0, 20, 40, 0.95) 0%,
      rgba(0, 10, 30, 0.98) 50%,
      rgba(0, 5, 20, 1) 100%);
    overflow: hidden;
  }

  /* 居中的大标题 */
  .section6-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: calc(100vw * 48 / 1920);
    font-weight: 700;
    color: rgba(255, 255, 255, 0.95);
    text-align: center;
    text-shadow:
      0 0 40px rgba(0, 150, 255, 0.8),
      0 0 80px rgba(0, 150, 255, 0.6),
      0 0 120px rgba(0, 150, 255, 0.4);
    letter-spacing: 6px;
    z-index: 100;
    animation: titleGlow 4s ease-in-out infinite;
    user-select: none;
    white-space: nowrap;
  }

  /* 中心发光核心 */
  .central-core {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 200px;
  }

  .core-ring {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid rgba(0, 150, 255, 0.6);
    border-radius: 50%;
    animation: coreRingPulse 4s ease-in-out infinite;
  }

  .core-ring.ring-1 {
    width: 100px;
    height: 100px;
    animation-delay: 0s;
  }

  .core-ring.ring-2 {
    width: 150px;
    height: 150px;
    animation-delay: 1s;
  }

  .core-ring.ring-3 {
    width: 200px;
    height: 200px;
    animation-delay: 2s;
  }

  .core-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    background: radial-gradient(circle,
      rgba(255, 255, 255, 1) 0%,
      rgba(0, 150, 255, 0.8) 50%,
      transparent 100%);
    border-radius: 50%;
    box-shadow: 0 0 40px rgba(0, 150, 255, 0.8);
    animation: coreCenterGlow 3s ease-in-out infinite;
  }

  /* 多层旋转环 */
  .rotating-rings {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .ring {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid rgba(0, 150, 255, 0.3);
    border-radius: 50%;
  }

  .outer-ring-1 {
    width: 500px;
    height: 500px;
    animation: ringRotateClockwise 20s linear infinite;
  }

  .outer-ring-2 {
    width: 650px;
    height: 650px;
    animation: ringRotateCounterClockwise 15s linear infinite;
  }

  .outer-ring-3 {
    width: 800px;
    height: 800px;
    animation: ringRotateClockwise 25s linear infinite;
  }

  .outer-ring-4 {
    width: 950px;
    height: 950px;
    animation: ringRotateCounterClockwise 30s linear infinite;
  }

  /* 轨道粒子 */
  .orbital-particles {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .particle-orbit {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
  }

  .particle-orbit.orbit-1 {
    width: 400px;
    height: 400px;
    animation: orbitRotation1 8s linear infinite;
  }

  .particle-orbit.orbit-2 {
    width: 550px;
    height: 550px;
    animation: orbitRotation2 12s linear infinite;
  }

  .particle-orbit.orbit-3 {
    width: 700px;
    height: 700px;
    animation: orbitRotation3 16s linear infinite;
  }

  .orbit-particle {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 8px;
    height: 8px;
    background: rgba(0, 150, 255, 0.9);
    border-radius: 50%;
    box-shadow: 0 0 15px rgba(0, 150, 255, 0.7);
    animation: particleGlow 2s ease-in-out infinite;
  }

  /* 脉冲波纹 */
  .pulse-waves {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .pulse-wave {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid rgba(0, 150, 255, 0.4);
    border-radius: 50%;
    animation: pulseWaveExpand 6s ease-out infinite;
  }

  .pulse-wave.wave-1 {
    animation-delay: 0s;
  }

  .pulse-wave.wave-2 {
    animation-delay: 2s;
  }

  .pulse-wave.wave-3 {
    animation-delay: 4s;
  }

  /* 数据流环形轨道 */
  .data-orbital-streams {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .stream-orbit {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
  }

  .stream-orbit.stream-orbit-1 {
    width: 520px;
    height: 520px;
    animation: streamOrbitRotate1 10s linear infinite;
  }

  .stream-orbit.stream-orbit-2 {
    width: 680px;
    height: 680px;
    animation: streamOrbitRotate2 14s linear infinite reverse;
  }

  .stream-dot {
    position: absolute;
    width: 6px;
    height: 6px;
    background: rgba(0, 150, 255, 0.8);
    border-radius: 50%;
    box-shadow: 0 0 12px rgba(0, 150, 255, 0.6);
    animation: dotPulse 1.5s ease-in-out infinite;
  }

  .stream-orbit-1 .dot-1 {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    animation-delay: 0s;
  }

  .stream-orbit-1 .dot-2 {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    animation-delay: 0.5s;
  }

  .stream-orbit-1 .dot-3 {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    animation-delay: 1s;
  }

  .stream-orbit-2 .dot-1 {
    top: 25%;
    right: 25%;
    animation-delay: 0.2s;
  }

  .stream-orbit-2 .dot-2 {
    bottom: 25%;
    right: 25%;
    animation-delay: 0.7s;
  }

  .stream-orbit-2 .dot-3 {
    bottom: 25%;
    left: 25%;
    animation-delay: 1.2s;
  }

  /* 能量射线 */
  .energy-rays {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .ray {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 2px;
    height: 200px;
    background: linear-gradient(180deg,
      rgba(0, 150, 255, 0.8),
      transparent);
    transform-origin: bottom center;
    animation: rayRotate 15s linear infinite;
  }

  .ray.ray-1 {
    transform: translate(-50%, -100%) rotate(0deg);
    animation-delay: 0s;
  }

  .ray.ray-2 {
    transform: translate(-50%, -100%) rotate(60deg);
    animation-delay: 2.5s;
  }

  .ray.ray-3 {
    transform: translate(-50%, -100%) rotate(120deg);
    animation-delay: 5s;
  }

  .ray.ray-4 {
    transform: translate(-50%, -100%) rotate(180deg);
    animation-delay: 7.5s;
  }

  .ray.ray-5 {
    transform: translate(-50%, -100%) rotate(240deg);
    animation-delay: 10s;
  }

  .ray.ray-6 {
    transform: translate(-50%, -100%) rotate(300deg);
    animation-delay: 12.5s;
  }

  /* 外围装饰环 */
  .decorative-elements {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .deco-arc {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 3px solid transparent;
    border-top: 3px solid rgba(0, 150, 255, 0.4);
    border-radius: 50%;
    animation: arcRotate 8s linear infinite;
  }

  .deco-arc.arc-1 {
    width: 1100px;
    height: 1100px;
    border-right: 3px solid rgba(0, 150, 255, 0.4);
    animation-delay: 0s;
  }

  .deco-arc.arc-2 {
    width: 1200px;
    height: 1200px;
    border-left: 3px solid rgba(0, 150, 255, 0.3);
    animation-delay: 2s;
    animation-direction: reverse;
  }

  .deco-arc.arc-3 {
    width: 1300px;
    height: 1300px;
    border-bottom: 3px solid rgba(0, 150, 255, 0.2);
    animation-delay: 4s;
  }

  .deco-arc.arc-4 {
    width: 1400px;
    height: 1400px;
    border-left: 3px solid rgba(0, 150, 255, 0.2);
    border-bottom: 3px solid rgba(0, 150, 255, 0.2);
    animation-delay: 6s;
    animation-direction: reverse;
  }
}
.section7 {
  top: 700%;
}

/* 设置当前活动的section的样式 */
.active {
  display: block;
}
</style>

<script>
import { mapState } from "vuex";
export default {
  metaInfo: {
    // 设置关键词
    meta: {
      keywords: "智慧港口,只能运维平台,数字孪生,",
    },
  },
  data() {
    return {
      // this.$store.state.currentIndex: 0,
      translateY: 0,
      randomChars: [],
      wheelCount: 0,
      WHEEL_THRESHOLD: 4,
    };
  },
  created() {
    // 生成静态数据字符数组
    const chars = '01ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%^&*()_+-=[]{}|;:,.<>?';
    for (let i = 0; i < 750; i++) { // 25列 * 30行
      this.randomChars.push(chars[Math.floor(Math.random() * chars.length)]);
    }
    
    this.$nextTick(() => {
      const bodyStyle = document.body.style; // 获取body样式
      bodyStyle.overflow = "hidden"; // 设置溢出内容为隐藏
      const htmlStyle = document.getElementsByTagName("html")[0].style; // 获取html样式
      htmlStyle.overflow = "hidden"; // 设置溢出内容为隐藏
    });
  },
  computed: {
    ...mapState(["currentIndex"]),
  },
  mounted() {
    window.addEventListener("wheel", this.handleWheel);
  },
  beforeDestroy() {
    window.removeEventListener("wheel", this.handleWheel);
  },
  methods: {
    handleWheel(event) {
      this.wheelCount++;
      if (this.wheelCount >= this.WHEEL_THRESHOLD) {
        const deltaY = event.deltaY;
        if (deltaY > 0 && this.$store.state.currentIndex < 7) {
          this.$store.state.currentIndex++;
          this.translateY -= 100;
        } else if (deltaY < 0 && this.$store.state.currentIndex > 0) {
          this.$store.state.currentIndex--;
          this.translateY += 100;
        }
        if (this.$store.state.currentIndex == 0) {
          this.translateY = 0;
        }
        // 在这里执行您想要进行的操作
        this.wheelCount = 0; // 重置计数器
      }
    },
    scrollToNext() {
      if (this.$store.state.currentIndex < 7) {
        this.$store.state.currentIndex++;
        this.translateY -= 100;
      }
    },
  },
  watch: {
    currentIndex(n, o) {
      if (n == 0) {
        this.translateY = 0;
      }
      if (n) {
        if (n == 1) {
          this.translateY = -100;
        }
        if (n == 2) {
          this.translateY = -200;
        }
        if (n == 3) {
          this.translateY = -300;
        }
        if (n == 4) {
          this.translateY = -400;
        }
        if (n == 5) {
          this.translateY = -500;
        }
        if (n == 6) {
          this.translateY = -600;
        }
        if (n == 7) {
          this.translateY = -700;
        }
      }
    },
  },
};
</script>
